import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getCommercialName } from "../constants/commercialNames";
import { getAuthUser } from "../hooks/useAuthToken";
import { apiV2PostConfig } from "../helpers/api_helper";

interface MenuService {
    id: string;
    label: string;
    link: string;
    icon: string;
    categoryLabel: string;
    categoryId: number | string;
    dataTitle: string;
}

interface CategoryResponse {
    id: number | string;
    label: string;
}

const Navdata = () => {
    const history = useNavigate();

    const [isDashboard, setIsDashboard] = useState<boolean>(false);
    const [isProfile, setIsProfile] = useState<boolean>(false);
    const [isContrats, setIsContrats] = useState<boolean>(false);
    const [isServices, setIsServices] = useState<boolean>(false);
    const [isFactures, setIsFactures] = useState<boolean>(false);
    const [isFlotte, setIsFlotte] = useState<boolean>(false);
    const [isLiens, setIsLiens] = useState<boolean>(false);
    const [isVoix, setIsVoix] = useState<boolean>(false);
    const [isDemandes, setIsDemandes] = useState<boolean>(false);
    const [isSupport, setIsSupport] = useState<boolean>(false);

    const [iscurrentState, setIscurrentState] = useState("Profile");
    const [services, setServices] = useState<MenuService[]>([]);
    const [loadingServices, setLoadingServices] = useState<boolean>(true);

    const fetchCategories = async (): Promise<CategoryResponse[]> => {
        try {
            const authUser = getAuthUser();
            if (!authUser?.token) return [];
            const entity = authUser.entity || 1;

            const response: any = await axios.post(
                "/apiV2/",
                {
                    action: "getCategories",
                    entity: entity,
                },
                apiV2PostConfig()
            );

            const categoriesData = response.data || response;

            if (Array.isArray(categoriesData)) {
                return categoriesData as CategoryResponse[];
            }
            return [];
        } catch (error) {
            console.error("Erreur lors du chargement des catégories:", error);
            return [];
        }
    };

    useEffect(() => {
        const loadData = async () => {
            setLoadingServices(true);

            const categoriesData = await fetchCategories();

            if (categoriesData && Array.isArray(categoriesData)) {
                const menuServices: MenuService[] = categoriesData
                    .filter((cat) => {
                        const normalizedLabel = cat.label.toLowerCase().trim();
                        return normalizedLabel !== 'materiel' && normalizedLabel !== 'matériel';
                    })
                    .map((cat) => ({
                        id: `category-${cat.id}`,
                        label: getCommercialName(cat.label),
                        link: `/services/${cat.id}`,
                        icon: "ri-service-line",
                        categoryLabel: cat.label,
                        categoryId: cat.id,
                        dataTitle: getCommercialName(cat.label),
                    }));

                setServices(menuServices);
            }

            setLoadingServices(false);
        };

        loadData();
    }, []);

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul?.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];

            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement;
                if (getID) getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove("twocolumn-panel");

        if (iscurrentState !== "Dashboard") setIsDashboard(false);
        if (iscurrentState !== "Profile") setIsProfile(false);
        if (iscurrentState !== "Contrats") setIsContrats(false);
        if (iscurrentState !== "Services") setIsServices(false);
        if (iscurrentState !== "Factures") setIsFactures(false);
        if (iscurrentState !== "Flotte") setIsFlotte(false);
        if (iscurrentState !== "Liens") setIsLiens(false);
        if (iscurrentState !== "Voix") setIsVoix(false);
        if (iscurrentState !== "Support") setIsSupport(false);
    }, [history, iscurrentState]);

    const menuItems: any = [
        {
            label: "ESPACE CLIENT",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Tableau de bord",
            icon: "ri-dashboard-3-line",
            link: "/dashboard",
            dataTitle: "Tableau de bord",
            click: function (e: any) {
                e.preventDefault();
                history("/dashboard");
                setIsDashboard(!isDashboard);
                setIscurrentState("Dashboard");
                updateIconSidebar(e);
            },
            stateVariables: isDashboard,
        },
        {
            id: "profile",
            label: "Mon Profil",
            icon: "ri-user-settings-line",
            link: "/profile",
            dataTitle: "Mon Profil",
            click: function (e: any) {
                e.preventDefault();
                history("/profile");
                setIsProfile(!isProfile);
                setIscurrentState("Profile");
                updateIconSidebar(e);
            },
            stateVariables: isProfile,
        },
        {
            label: "SERVICES",
            isHeader: true,
        },
        {
            id: "contrats",
            label: "Mes Contrats & Services",
            icon: "ri-file-list-3-line",
            link: "/services",
            dataTitle: "Mes Contrats & Services",
            click: function (e: any) {
                e.preventDefault();
                history("/services");
                setIsContrats(!isContrats);
                setIscurrentState("Contrats");
                updateIconSidebar(e);
            },
            stateVariables: isContrats,
        },
        {
            id: "factures",
            label: "Mes Factures",
            icon: "ri-bill-line",
            link: "/mesfactures",
            dataTitle: "Mes Factures",
            click: function (e: any) {
                e.preventDefault();
                history("/mesfactures");
                setIsFactures(!isFactures);
                setIscurrentState("Factures");
                updateIconSidebar(e);
            },
            stateVariables: isFactures,
        },
        // {
        //     id: "services",
        //     label: "Mes Services",
        //     icon: "ri-service-line",
        //     link: "/#",
        //     dataTitle: "Mes Services",
        //     hasDropdown: true,
        //     click: function (e: any) {
        //         e.preventDefault();
        //         setIsServices(!isServices);
        //         setIscurrentState("Services");
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: isServices,
        //     subItems: loadingServices
        //         ? [{ id: "loading", label: "Chargement...", link: "#" }]
        //         : services.length > 0
        //             ? services
        //             : [{ id: "no-services", label: "Aucun service disponible", link: "#" }]
        // },
        {
            id: "flotte-mobile",
            label: "Flotte Mobile",
            icon: "ri-smartphone-line",
            link: "/flotte-mobile",
            dataTitle: "Flotte Mobile",
            click: function (e: any) {
                e.preventDefault();
                history("/flotte-mobile");
                setIsFlotte(!isFlotte);
                setIscurrentState("Flotte");
                updateIconSidebar(e);
            },
            stateVariables: isFlotte,
        },
        {
            id: "mes-liens",
            label: "Mes Liens",
            icon: "ri-global-line",
            link: "/mes-liens",
            dataTitle: "Mes Liens",
            click: function (e: any) {
                e.preventDefault();
                history("/mes-liens");
                setIsLiens(!isLiens);
                setIscurrentState("Liens");
                updateIconSidebar(e);
            },
            stateVariables: isLiens,
        },
        {
            id: "telephonie-fixe",
            label: "Téléphonie Fixe",
            icon: "ri-phone-line",
            link: "/telephonie-fixe",
            dataTitle: "Téléphonie Fixe",
            click: function (e: any) {
                e.preventDefault();
                history("/telephonie-fixe");
                setIsVoix(!isVoix);
                setIscurrentState("Voix");
                updateIconSidebar(e);
            },
            stateVariables: isVoix,
        },
        {
            label: "ASSISTANCE",
            isHeader: true,
        },
        {
            id: "demandes",
            label: "Mes Demandes",
            icon: "ri-inbox-archive-line",
            link: "/mes-demandes",
            dataTitle: "Mes Demandes",
            click: function (e: any) {
                e.preventDefault();
                history("/mes-demandes");
                setIsDemandes(!isDemandes);
                setIscurrentState("Demandes");
                updateIconSidebar(e);
            },
            stateVariables: isDemandes,
        },
        {
            id: "support",
            label: "Support & Aide",
            icon: "ri-customer-service-2-line",
            link: "/support",
            dataTitle: "Support & Aide",
            click: function (e: any) {
                e.preventDefault();
                history("/support");
                setIsSupport(!isSupport);
                setIscurrentState("Support");
                updateIconSidebar(e);
            },
            stateVariables: isSupport,
        },
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
